import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: null,
};

export const orgInfoDetails = createSlice({
    name: 'orgInfoDetail',
    initialState,
    reducers: {
        orgInfoDetail: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { orgInfoDetail } = orgInfoDetails.actions;

export default orgInfoDetails.reducer;